import React from 'react';

import {
	FormattedDate,
	FormattedMessage,
	FormattedRelativeTime,
	type MessageDescriptor,
} from 'react-intl';

import { Box } from '@atlaskit/primitives/compiled';
import Tooltip from '@atlaskit/tooltip/Tooltip';

import { getRelativeTimeSince } from '../../utils/search-result-utils';

import { messages } from './messages';

type LastModifiedProps = {
	lastModified: string | undefined;
	message?: MessageDescriptor;
};

export const LastModified = ({
	lastModified,
	message = messages.lastModified,
}: LastModifiedProps): React.JSX.Element | null => {
	if (!lastModified) {
		return null;
	}
	const lastModifiedDate = new Date(lastModified);
	const { value, unit } = getRelativeTimeSince(lastModifiedDate);

	const absoluteDate = (
		<FormattedDate value={lastModified} month="short" day="numeric" year="numeric" />
	);

	return (
		<Tooltip content={absoluteDate}>
			{(tooltipProps) => (
				<Box {...tooltipProps}>
					<FormattedMessage
						{...message}
						values={{
							formattedDate: <FormattedRelativeTime value={-value} unit={unit} />,
						}}
					/>
				</Box>
			)}
		</Tooltip>
	);
};
